import React from 'react';
export function Footer() {
  return <footer className="mt-16 pt-10 border-t border-gray-200 pb-12" data-id="element-51">
      <h4 className="text-lg font-bold mb-4 text-[#2D2D2D]" data-id="element-52">
        Over Stressless Dogs
      </h4>
      <p className="text-sm text-gray-600 leading-relaxed mb-8" data-id="element-53">
        Stressless Dogs is opgericht door Amee de Bruijn en helpt
        hondeneigenaren om op een liefdevolle, wetenschappelijk onderbouwde
        manier met hun hond te communiceren. Zonder dwang, correcties of
        dominantie. Meer dan 100.000 baasjes volgden hun webinars, en 15.000+
        honden werden geholpen via hun cursussen.
      </p>
      <div className="text-xs text-gray-400 flex justify-between items-center" data-id="element-54">
        <span data-id="element-55">© {new Date().getFullYear()} Stressless Dogs</span>
        <div className="space-x-4" data-id="element-56">
          <a href="https://stresslessdogs.nl/mc-communiceren" className="hover:text-gray-600" data-id="element-57">
            Privacy
          </a>
          <a href="https://stresslessdogs.nl/mc-communiceren" className="hover:text-gray-600" data-id="element-58">
            Voorwaarden
          </a>
        </div>
      </div>
    </footer>;
}